import React, { useState } from "react";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice"
import { Layout } from "@kursk/components/Layout/Layout";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { Socials } from "../Home/Socials/Socials";
import { getEntitiesListTitle } from "@kursk/utils/getEntitiesListTitle";
import styles from './Restaurants.module.scss';
import { Filters } from "@kursk/components/ui/Filters/Filters";
import { SwitchMapButton } from "@kursk/components/ui/SwitchMapButton/SwitchMapButton";
import { restaurantsSlice } from "@common/redux/slices/entities.slice";
import { RestaurantsGrid } from "./RestaurantsGrid/RestaurantsGrid";
import { RestaurantsMap } from "./RestaurantsMap/RestaurantsMap";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import { HeroBlock } from "@kursk/components/ui/HeroBlock/HeroBlock";
import { picksSlice } from "@common/redux/slices/picks";
import { LdJson } from "@kursk/components/seo/LdJson";
import { CatalogueTitle } from "@kursk/components/ui/CatalogueTitle/CatalogueTitle";
import { themeValue } from "@kursk/themes";
import { regionContent } from "@kursk/content/regionContent";

export const Restaurants = () => {
  const { total, meta, filters, items } = useSelectSlice(restaurantsSlice);
  const { listEvents, listTouristRoutes, listOverviews } = useSelectSlice(recommendationSlice);
  const selectedTags = filters.allTags;
  const selectedTag = (meta.tags && selectedTags.length === 1) && meta.tags.find((tag) => tag._id === selectedTags[0]);
  const { bannersInCatalogs } = useSelectSlice(picksSlice);
  const [currentView, setCurrentView] = useState<'list' | 'map'>('list');

  const onSwitchToMap = () => {
    setCurrentView('map');
  };

  const onSwitchToList = () => {
    setCurrentView('list');
  };

  return (
    <Layout showSubscribePopup={false}>
      <SeoMetaTitles
        page="restaurants"
        selectedTag={selectedTag}
        titleOg={getEntitiesListTitle(meta.tags, selectedTags, 'рестораны')}
        meta={meta}
      />
      <HeroBlock banners={bannersInCatalogs} page="restaurants"/>
      <section className={styles.section_content}>
        <div className={styles.header}>
          <CatalogueTitle
            page="restaurants"
            tags={meta.tags}
            selectedTags={selectedTags}
            title={themeValue({
              astrakhan: 'где поесть',
              default: 'рестораны',
            })}
            dashTitle={'Найдено ресторанов'}
            total={total}
            withSwitchMap={regionContent.componentsConfig?.restaurantsWithMap}
            switchMapComponent={(
              <SwitchMapButton
                currentView={currentView}
                onSwitchToMapClick={onSwitchToMap}
                onSwitchToListClick={onSwitchToList}
              />
            )}
          />
        </div>
        <div className={styles.filters}>
          <Filters
            entityType={'restaurants'}
            meta={meta}
            filters={filters}
            withLocales
            withPrices
            withPricesOptions={{
              dropDownTitle: 'Цена среднего чека (₽)'
            }}/>
        </div>
        <div className={styles.items}>
          {items && items.length > 0 && items.map(item => {
            return (
              <LdJson
                key={item._id}
                entity={item}
                type={'restaurants'}
              />
            )
          }
          )}
          {currentView === 'list' && (
            <RestaurantsGrid />
          )}
          {currentView === 'map' && (
            <RestaurantsMap filters={filters} />
          )}
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType={'events'}
            data={listEvents}
            title={'Рекомендуем посетить'}
            goTo={'/events'}
            goToTitle={'все события'}/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType={'routes'}
            data={listTouristRoutes}
            title={'Рекомендуем спланировать маршрут'}
            goTo={'/touristroutes'}
            goToTitle={'все маршруты'}/>
        </div>
        <div className={styles.recommendationSection}>
          <RecommendationsBlock
            entityType={'overviews'}
            data={listOverviews}
            title={'Рекомендуем почитать'}
            goTo={'/overviews'}
            goToTitle={'все обзоры'}/>
        </div>
        <div className={styles.recommendationSection}>
          <SubscribeFooterForm/>
        </div>
        <div className={styles.section}>
          <Socials/>
        </div>
      </section>
    </Layout>
  );
}
